import { getAxiosInstance } from '../blocks/axios/axiosFactory';

const url = "/document";

export default class DocumentService {
    static getDocument(documentContentToken: string) {
        return getAxiosInstance().get(`${url}/get`, { params: { documentContentToken } });
    }
}
